var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMandatoryMessagesBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 182,
    viewBox: "0 0 404 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_460_7552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 404,
    height: 182
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 404,
    height: 181,
    rx: 20,
    fill: "#E36867"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_460_7552)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 404,
    height: 182.398,
    rx: 20,
    fill: "#2896BE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.5,
    cy: 84.5,
    rx: 94.5,
    ry: 84.5,
    transform: "matrix(-1 0 0 1 404 -60.5)",
    fill: "url(#paint0_linear_460_7552)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.5,
    cy: 105.5,
    rx: 115.5,
    ry: 105.5,
    transform: "matrix(-1 0 0 1 202 75.5)",
    fill: "url(#paint1_linear_460_7552)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_7552",
    x1: 216.052,
    y1: 191.105,
    x2: 143.262,
    y2: 93.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_460_7552",
    x1: -36.6414,
    y1: -38.0164,
    x2: 103.524,
    y2: 95.3495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandatoryMessagesBackground);
export default __webpack_public_path__ + "static/media/MandatoryMessagesBackground.987634d32b9b36f0e12b8a0457d33beb.svg";
export { ForwardRef as ReactComponent };